export default "__VITE_ASSET__Cv3DOArV__"